import { request } from "../request";

type S3UploadParams = {
  fields: {
    [key: string]: string;
  };
  url: string;
};

export async function uploadToS3(uploadParams: S3UploadParams, file: File): Promise<undefined> {
  const data = new FormData();

  for (const [key, value] of Object.entries(uploadParams.fields)) {
    data.append(key, value);
  }

  data.append("Content-Type", file.type);

  /* file must be the last field in form data, everything after it is ignored
     https://docs.aws.amazon.com/AmazonS3/latest/API/RESTObjectPOST.html */
  data.append("file", file);

  return request({
    url: uploadParams.url,
    method: "POST",
    data,
    includeReferrerUrlHeader: false,
  });
}
